<dx-toolbar class="yo-toolbar">
  <dxi-item location="before">
    <div class="custom-toolbar-subdivision">
      <yo-help lang="fr" [file]="pathFile" [dialogMsgSupplier]="help()" [width]="800"></yo-help>
      <yo-button
        label="Créer"
        iconClass="fa fa-plus"
        [theme]="ButtonThemeEnum.ADD"
        (onClick)="createFiliale()"
        [disabled]="!canEdit()"
        tooltip="Créer un fournisseur">
      </yo-button>
    </div>
  </dxi-item>
</dx-toolbar>


<dx-data-grid
  [dataSource]="fournisseurList"
  [allowColumnResizing]="true"
  [remoteOperations]="true"
  [hoverStateEnabled]="true"
  [rowAlternationEnabled]="true"
  [showRowLines]="true"
  keyExpr="id"
  height="auto"

  [showBorders]="true"
  #grid>

  <dxi-column dataField="id" caption="Actions" alignment="center" [allowEditing]="false"
              cellTemplate="actionCellTemplate" ></dxi-column>
  <dxi-column dataField="libelle" caption="Filiale" alignment="center" [allowEditing]="false"
              ></dxi-column>
  <dxi-column dataField="code" caption="Code" alignment="center" [allowEditing]="false"
              ></dxi-column>
  <dxi-column dataField="adresse" caption="Adresse" alignment="center" [allowEditing]="false"
              cellTemplate="adresseCellTemplate"
              ></dxi-column>
  <dxi-column dataField="adresse" caption="Téléphone" alignment="center" [allowEditing]="false"

              cellTemplate="telephoneCellTemplate"></dxi-column>

  <dxi-column dataField="secteurFournisseurList"
              caption="Secteurs"
              [cellTemplate]="cellTemplate"
              >
    <dxo-lookup
      [dataSource]="secteurList"
      displayExpr="libelle"
      valueExpr="id">
    </dxo-lookup>
  </dxi-column>

  <dxi-column dataField="francoDePortActif" caption="Franco port (FP)" alignment="center" [allowEditing]="false"
              ></dxi-column>
  <dxi-column dataField="francoDePortMontant" caption="Montant minimum FP" alignment="center" [allowEditing]="false"
              ></dxi-column>
  <dxi-column dataField="francoDePortPoids" caption="Poids minimum FP" alignment="center" [allowEditing]="false"
              ></dxi-column>


  <!--    TEMPLATE ADRESSE -->
  <div *dxTemplate="let cell of 'adresseCellTemplate'">
    <div>
      <span *ngIf="cell.row.data.adresse"> {{getTooltipAdresse(cell.row.data.adresse)}}</span>
    </div>
  </div>

  <!--    TEMPLATE TELEPHONE-->
  <div *dxTemplate="let cell of 'telephoneCellTemplate'">
    <div>
      <span> {{cell.row.data.adresse.telephone}}</span>
    </div>
  </div>

  <!--    TEMPLATE TELEPHONE-->
  <div *dxTemplate="let cell of 'actionCellTemplate'" class="custom-button-container">
    <yo-button
      [iconClass]="canEdit() ? 'fas fa-edit' : 'fas fa-eye'"
      [theme]="ButtonThemeEnum.DEFAULT_INNER"
      (onClick)="editFiliale(cell.row.data)"
      [disabled]="isDisabledCreateBtn()"
      tooltip="Editer une filiale">
    </yo-button>
    <yo-button
      iconClass="fas fa-book-open"
      [theme]="ButtonThemeEnum.SECONDARY_INNER"
      (onClick)="openDialogCatalogue(cell.row.data)"
      tooltip="Voir le catalogue articles de la filiale">
    </yo-button>
  </div>
</dx-data-grid>

<!--DIALOG FOURNISSEUR FICHE IDENTITE-->
<yo-filiale-form-dialog
  [displayDialog]="displayFormDialog"
  (onClose)="onCloseFormDialog($event)"
></yo-filiale-form-dialog>
